var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4697 0.171875H1.59546C0.739232 0.171875 0.046875 0.847845 0.046875 1.68359V19.6316C0.046875 20.4674 0.739232 21.1474 1.59546 21.1474H19.4697C20.326 21.1474 21.0224 20.4674 21.0224 19.6357V1.68359C21.0224 0.847845 20.326 0.171875 19.4697 0.171875ZM6.26989 18.0462H3.15634V8.03361H6.26989V18.0462ZM4.71312 6.66938C3.7135 6.66938 2.90643 5.86231 2.90643 4.86679C2.90643 3.87127 3.7135 3.06421 4.71312 3.06421C5.70863 3.06421 6.5157 3.87127 6.5157 4.86679C6.5157 5.85822 5.70863 6.66938 4.71312 6.66938ZM17.9212 18.0462H14.8117V13.1792C14.8117 12.0198 14.7912 10.5245 13.1935 10.5245C11.5752 10.5245 11.3294 11.7904 11.3294 13.0972V18.0462H8.22406V8.03361H11.2065V9.40194H11.2475C11.6613 8.61535 12.6773 7.78371 14.189 7.78371C17.3394 7.78371 17.9212 9.85668 17.9212 12.5524V18.0462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.5bb53c70b462505dbd3517f1d2bdb51d.svg";
export { ForwardRef as ReactComponent };